import { Injectable } from '@angular/core';

export class Messages {
  id: number;
  mode: number;
  icon: number;
  message: string;
}

@Injectable()
export class MessageService {

  public getMessageDescription = function (_id) {
    var row = this.commonMessages.filter(item => item.id==_id);  
      if (row.length === 1) {
          return row;
      } else {
          return null;
      }
    }
      // エラーメッセージ定義
    //icon:1=異常終了系、2=正常終了系、10=確認系
    commonMessages:Messages[] = [
      { id: 10001, mode:2, icon: 2, message: '保存しました' },
      { id: 10002, mode:2, icon: 2, message: '削除しました' },
      { id: 10003, mode:2, icon: 2, message: '変更しました' },
      { id: 10004, mode:2, icon: 2, message: '完了しました' },
      { id: 10005, mode:2, icon: 2, message: '送信しました' },
      { id: 10006, mode:2, icon: 2, message: '初期化しました' },
      { id: 10007, mode:2, icon: 2, message: '変更しました<br>------------------------------<br>changed' },
      { id: 10008, mode:2, icon: 2, message: '送信しました<br>------------------------------<br>Answerd sent successfully.' },
      { id: 10009, mode:2, icon: 2, message: '保存しました<br>------------------------------<br>Saved answerd.' },
      { id: 10010, mode:2, icon: 2, message: '取込開始しました。<br>状況を確認する場合は「再読込」ボタンをクリックしてください。' },
      { id: 10011, mode:2, icon: 2, message: '処理中のため取込出来ません。<br>状況を確認する場合は「再読込」ボタンをクリックしてください。' },
      { id: 10012, mode:2, icon: 2, message: '出力開始しました。<br>状況を確認する場合は「再読込」ボタンをクリックしてください。' },
      { id: 10013, mode:2, icon: 2, message: 'キャンセルしました<br>------------------------------<br>canceled' },
      { id: 10014, mode:2, icon: 2, message: '受付しました' },
      { id: 10015, mode:2, icon: 2, message: '一括作成処理を開始しました。<br>状況を確認する場合は「再読込」ボタンをクリックしてください。' },
      { id: 11001, mode:2, icon: 1, message: '保存できませんでした' },
      { id: 11002, mode:2, icon: 1, message: '他者により更新されています' },
      { id: 11003, mode:2, icon: 1, message: 'サーバー問合せに失敗しました' },
      { id: 11004, mode:2, icon: 1, message: '処理できませんでした' },
      { id: 11005, mode:2, icon: 1, message: '取込に失敗しました。ファイルを確認してください' },
      { id: 11006, mode:2, icon: 1, message: '対象データが存在しません' },
      { id: 11007, mode:2, icon: 1, message: '対象のイベントが存在しません' },
      { id: 11008, mode:2, icon: 1, message: '対象の問診票が存在しません' },
      { id: 11009, mode:2, icon: 1, message: '対象の問診が存在しません' },
      { id: 11010, mode:2, icon: 1, message: 'アカウントがロックされています。管理者へ連絡してください。<br>------------------------------<br>Your account is Locked. Please contact Administrator.' },
      { id: 11011, mode:2, icon: 1, message: 'パスワードの有効期限が切れています。パスワードを変更してください。<br>------------------------------<br>Password has expired. Please change your Password.' },
      { id: 11012, mode:2, icon: 1, message: "希望した枠の予約が満席になりました。再度選択してください。<br>------------------------------<br>The seat you requested has been booked. Please select again." },
      { id: 11013, mode:2, icon: 1, message: '長時間操作がなかったため、ページの再読み込みを行います。<br>------------------------------<br>Since there was no operation for a long time, the page will be reloaded.' },
      { id: 12002, mode:2, icon: 1, message: 'チェック完了<br>問題なく登録できる状態です'},
      { id: 19001, mode:2, icon: 1, message: '' },    /*空メッセージ*/
      { id: 50001, mode:1, icon: 10, message: '保存してもよろしいですか？' },
      { id: 50002, mode:1, icon: 10, message: '削除してもよろしいですか？' },
      { id: 50003, mode:1, icon: 10, message: '変更してもよろしいですか？' },
      { id: 50004, mode:1, icon: 10, message: '複写してもよろしいですか？' },
      { id: 50005, mode:1, icon: 10, message: '編集中の内容を破棄してもよろしいですか？' },
      { id: 50006, mode:1, icon: 10, message: '選択されていませんが、保存してよろしいですか？' },
      { id: 50007, mode:1, icon: 10, message: '保存されていませんが、キャンセルしてよろしいですか？' },
      { id: 50008, mode:1, icon: 10, message: '選択されている送信リストは破棄されます。よろしいですか？' },
      { id: 50009, mode:4, icon: 10, message: 'テンプレート名を入力してください' },
      { id: 50010, mode:1, icon: 10, message: '送信してもよろしいですか？' },
      { id: 50011, mode:1, icon: 10, message: 'パスワード初期化してもよろしいですか？' },
      { id: 50012, mode:1, icon: 10, message: '変更してもよろしいですか？<br>------------------------------<br>Are you sure you want to change?' },
      { id: 50013, mode:1, icon: 10, message: '送信してもよろしいですか？<br>------------------------------<br>Are you sure you want to send to?' },
      { id: 50014, mode:1, icon: 10, message: '保存してもよろしいですか？<br>------------------------------<br>Are you sure you want to save?' },
      { id: 50015, mode:1, icon: 10, message: '編集中の内容を破棄してもよろしいですか？<br>------------------------------<br>Are you sure you want to discard the contents of the editing?' },
      { id: 50016, mode:1, icon: 10, message: '添付しているファイルを破棄してもよろしいですか？<br>------------------------------<br>Are you sure you want to discard a file that is attached?' },
      { id: 50017, mode:1, icon: 10, message: 'キャンセルしてもよろしいですか？<br>------------------------------<br>Are you sure you want to cancel?' },
      { id: 50018, mode:1, icon: 10, message: '受付してもよろしいですか？' },
      { id: 50019, mode:1, icon: 10, message: '入力された情報で一括作成を行います。<br>よろしいですか？' },
      { id: 50020, mode:1, icon: 10, message: '受付の取り消しを行います。<br>よろしいですか？' },
      { id: 53001, mode:1, icon: 10, message: 'ファイルを出力しますか？' },
      { id: 54001, mode:1, icon: 10, message: 'CSVファイルを出力しますか？' },
      { id: 54002, mode:1, icon: 10, message: 'CSVファイルを取り込みますか？' },
      { id: 54003, mode:1, icon: 10, message: '回答を出力しますか？' },
      { id: 54004, mode:1, icon: 10, message: '受検者一覧を出力しますか？' },
      { id: 54005, mode:1, icon: 10, message: '特定化学物質の使用リストを出力しますか？' },
      { id: 54006, mode:1, icon: 10, message: '有機溶剤の使用リストを出力しますか？' },
      { id: 54007, mode:1, icon: 10, message: 'ファイル出力をキャンセルしますか？' },
      { id: 59001, mode:1, icon: 10, message: 'サインアウトしますか？<br>------------------------------<br>Do you sign out?' },
      { id: 90001, mode:2, icon: 1, message: '再読み込みはできません<br>ホーム画面からやり直してください<br>------------------------------<br>You can not re-read. Please try again from the home screen.' },
      { id: 90002, mode:2, icon: 1, message: '再読み込みはできません<br>管理者TOP画面からやり直してください' },
      { id: 91001, mode:1, icon: 10, message: '登録が完了しました<br>ホーム画面に戻りますか？'},
      { id: 10901, mode:1, icon: 10, message: "teamsのURLをメール送信します。よろしいですか？"},
      
  ];

}



// WEBPACK FOOTER //
// ./src/app/service/message.service.ts